<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  components: {},
  name: 'App',
  data() {
    return {}
  },
  mounted: function () {
    let title = this.configDatas['title'] || ''
    if (title) {
      document.title = title
    }
    this.getSign()
  },
  methods: {
    getSign: function () {
      let that = this
      let url = '/h5/api/weixin/jssdk/getSign?url=' + window.location.href
      this.apiGet(url, '', (res) => {
        if (res.state) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: [
              'chooseImage', // 选择图片
              'uploadImage', // 上传图片
              'updateTimelineShareData',
              'updateAppMessageShareData'
            ] // 必填，需要使用的JS接口列表
          })
          let link = window.location.protocol + '//' + document.domain

          // 分享到朋友圈
          wx.updateTimelineShareData({
            title: that.configDatas['title'], // 分享标题
            link: link + '/home?bid=' + localStorage.getItem('bid'), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://file.anquanfan.com/WechatIMG441.jpeg', // 分享图标
            success: function (res) {
              // 设置成功
              // console.log("设置成功", res);
            }
          })

          // 发送给朋友
          wx.updateAppMessageShareData({
            title: that.configDatas['title'], // 分享标题
            desc: that.configDatas['title'], // 分享描述
            link: link + '/home?bid=' + localStorage.getItem('bid'),
            imgUrl: 'https://file.anquanfan.com/WechatIMG441.jpeg', // 分享图标
            success: function () {
              // 设置成功
            }
          })
        } else {
          // this.$message(res.msg);
        }
      })
    }
  }
}
</script>

<style>
@import "../css/nomal.css";
</style>



// WEBPACK FOOTER //
// src/App.vue